import { render, staticRenderFns } from "./InterfaceCall.vue?vue&type=template&id=d4723d0c&scoped=true"
import script from "./InterfaceCall.vue?vue&type=script&lang=js"
export * from "./InterfaceCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4723d0c",
  null
  
)

export default component.exports